import React from 'react';
import { Link, navigate } from 'gatsby';
import { cnMerge } from '../../../../utils/utils';

const ShortcutLink = ({ href, isActive, onPress, link, children }) => {
  if (link) {
    return (
      <Link
        to={href}
        onClick={() => onPress()}
        className={`flex items-center shrink-0 w-fit h-full !text-clamp-md line-clamp-1 font-bold px-5 border-t-4 ${isActive ? 'border-primary-700 !text-primary-700' : 'border-primary-100'} transition-colors duration-300 ease-in-out global-hover`}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      role="link"
      type="button"
      onClick={() => {
        navigate(href);
        onPress();
      }}
      className={`block shrink-0 w-fit h-full !text-clamp-md line-clamp-1 font-bold px-5 border-t-4 ${isActive ? 'border-primary-700 !text-primary-700' : 'border-primary-100'} transition-colors duration-300 ease-in-out global-hover`}
    >
      {children}
    </button>
  );
};

const ShortcutsBar = ({
  shortcutsRef,
  fixed,
  scrollPosition,
  onPress,
  buttonTitles,
  className,
}) => (
  <div
    ref={shortcutsRef}
    className={cnMerge(
      className,
      `overflow-x-auto flex w-full min-h-16 z-30 ${fixed && 'fixed top-24 pt-[1px] right-0 left-0 bg-primary-50 bg-opacity-90 shadow-md'}`
    )}
  >
    <div className="flex w-full flex-row flex-1 sm:px-8 lg:mx-auto max-w-7xl">
      {buttonTitles.map((item, index) => (
        <ShortcutLink
          key={item.title}
          href={item.href}
          isActive={scrollPosition === index + 1}
          onPress={onPress}
          link={item.link}
        >
          {item.title}
        </ShortcutLink>
      ))}
    </div>
  </div>
);

export default ShortcutsBar;
